import React from 'react';
import { createComponent } from '@lit/react';
import { SDSLoader } from '../sds-loader/sds-loader';

export const SDSLoaderWrapper = createComponent({
	tagName: 'sds-loader',
	elementClass: SDSLoader,
	react: React,
	events: {},
});
